import React from 'react';

function TicketApproval(){

    return (
       
        <>
               
            <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        <span class="material-symbols-rounded">Approval</span>
                         </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Approval</h6> <span>Ticket Approval</span>
                        </div>
                    </div>
                    <div class="badge" style={{paddingTop:"15px"}}> <span>Pending</span> </div>
                </div>
                <div class="mt-3">

                <div>
                      <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>R2000</strong></p>


                     
                  

                    </span>
                </div>


           




            <div className='smallInfo' style={{display: "flex", marginTop:"20px"}}>
  
  <span class="material-symbols-rounded writing">calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Send for approval:</strong> 16 June 2013</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Approval: </strong>16 June 2013</span>


</div>


                 


<hr />

                    <div className="mt-3">

                     
                       
                    <div className='smallInfo' style={{display: "flex", justifyContent:"end"}}>
                           {/*
  <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", marginRight: "20px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >directions_car</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Visit site date</span></span>*/}

  <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", marginRight: "20px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >post_add</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Add Documents</span></span>


    <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px", width:"30%"}}><span class="material-symbols-rounded size"  style={{paddingTop:"3px"}} >approval</span> <span style={{paddingTop:"7px", paddingLeft:"5px"}}></span ><span style={{paddingTop:"6px"}} >Send For Approval </span></span>





  </div>

                    </div>



                </div>
            </div>
           


        </>
    )
}

export default TicketApproval;